import "./styles.css";
import { createLink } from "./protocol/events";
import { createScanner } from "./scanner";
import { onSettingChange, settings } from "./shared/settings";
import { setTrace } from "./shared/debug";
import { mountView } from "./view";
import { mountStagingDiagnostics } from "./shared/staging-diagnostics";

/**
 * Webscan2 — two halves and a link between them.
 *
 * The **scanner** (`src/scanner/`) owns the camera, the models and the funnel; the
 * **view** (`src/view/`) owns the page. Neither imports the other. They talk over the
 * typed link from `src/protocol/`, and this file is the one place that knows both exist:
 * it makes the link, hands each side its endpoint, and boots.
 *
 * The `<video>` element is the one thing both sides hold. The scanner treats it as the
 * camera's decoder surface — it attaches the stream and reads pixels — and the view
 * treats it as an element on the page, positioning it under the overlay. One element
 * rather than two on the same stream, because a second native video layer is memory iOS
 * does not have to spare.
 */

const surface = document.getElementById("cameraFeed");
if (!(surface instanceof HTMLVideoElement)) throw new Error("live camera video element missing");

// Required models load unconditionally while boot can request camera permission and
// display its preview. Recognition begins automatically once both are ready. Mount the
// view first so it hears every boot event.
const { scanner: scannerEndpoint, view: viewEndpoint } = createLink();
mountStagingDiagnostics(viewEndpoint, surface);
mountView(viewEndpoint);
const scanner = createScanner(scannerEndpoint, surface);

// Per-frame logging is a switch in the settings panel as well as a URL flag; the debug
// module is dependency-free, so the store is wired to it here.
setTrace(settings.trace);
onSettingChange((key) => {
  if (key === "trace") setTrace(settings.trace);
});

void scanner.boot();
